import React from "react";
import MentalRecoveryPreferences from "@/components/MentalRecoveryPreferences/MentalRecoveryPreferences";

const MentalRecoveryPreferencesPage: React.FC = () => {
  return <MentalRecoveryPreferences />;
};

export default MentalRecoveryPreferencesPage;
